import {api} from "../../shared/utils";
import {fetchAllPages} from "../../shared/utils/fetchAllPages";
import {environment} from "../../config/environment";

const baseUrl = environment.apiBaseURLClients;
const REFERENCE_PAGE_SIZE = 100;

const buildQuery = (params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '') return;
        query.set(key, value);
    });
    return query.toString();
};

const ROLES_PAGE_SIZE = 100;

export const listPermissions = () => fetchAllPages((page) => (
    api.get(`${baseUrl}/auth/roles?${buildQuery({page, size: ROLES_PAGE_SIZE})}`)
), {firstPage: 0});

export const createPermission = (payload) => api.post(`${baseUrl}/auth/roles`, payload);
export const updatePermission = (id, payload) => api.put(`${baseUrl}/auth/roles/${id}`, payload);
export const deletePermission = (id) => api.delete(`${baseUrl}/auth/roles/${id}`);

const listAllReference = (path, params) => fetchAllPages((page) => (
    api.get(`${baseUrl}/${path}?${buildQuery({page, pageSize: REFERENCE_PAGE_SIZE, ...params})}`)
));

export const listLicencasReference = () => listAllReference('licencas', {sortBy: 'atualizado_em', order: 'desc'});
export const listPlanosReference = () => listAllReference('planos-licenciamento', {sortBy: 'nome_plano', order: 'asc'});
export const listSistemasReference = () => listAllReference('sistemas', {sortBy: 'nome', order: 'asc'});
export const listModulosReference = () => listAllReference('modulos', {sortBy: 'nome', order: 'asc'});
export const listFuncionalidadesReference = () => listAllReference('funcionalidades', {sortBy: 'nome', order: 'asc'});
export const listRecursosReference = () => listAllReference('recursos', {sortBy: 'nome', order: 'asc'});
